import { useEffect, useState } from "react";
import { Selection } from "@dextall/panel-hooks-editor-2d";
import { Panel } from "../../panels/panel";
import { PanelEditorScope } from "../../panels/panel-editor-scope";
import { ActivatePanelHooksDesignerEventPayload } from "../../eventBus/hooksDesignerEventPayloads";
import eventBus, { IApplicationEvent } from "../../eventBus/eventDispatcher";

export const usePanelSelectedComponent = (panelEditorScope: PanelEditorScope) => {
    const [panel, setPanel] = useState<Panel>();
    const [selection, setSelection] = useState<Selection | null>(null);

    useEffect(() => {
        const onPanelSelected = (event: IApplicationEvent<ActivatePanelHooksDesignerEventPayload>) => {
            setPanel(event.payload.panel);
        };

        eventBus.addEventListener("Dextall.Hooks.Designer.Panel.SelectionChanged", onPanelSelected);

        return () => {
            eventBus.removeEventListener("Dextall.Hooks.Designer.Panel.SelectionChanged", onPanelSelected);
        };
    }, []);

    useEffect(() => {
        const onComponentSelectionChanged = () => {
            if (!panel) {
                return;
            }

            if (panelEditorScope.panelEditorContent?.selection) {
                setSelection({ ...panelEditorScope.panelEditorContent.selection });
            } else {
                setSelection(null);
            }
        };

        eventBus.addEventListener("Dextall.Hooks.Designer.Panel.ComponentSelectionChanged", onComponentSelectionChanged);

        return () => {
            eventBus.removeEventListener("Dextall.Hooks.Designer.Panel.ComponentSelectionChanged", onComponentSelectionChanged);
        };
    }, [panel, panelEditorScope]);

    return { panel, selection };
};
